import { Component, inject, input, ChangeDetectionStrategy, output, signal } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { RouterLink } from '@angular/router';
import {
  AlertComponent,
  ButtonComponent,
  CheckboxFieldWithErrorComponent,
  FormSectionComponent,
  TextFieldWithErrorComponent,
  DropdownFieldWithErrorComponent,
  DropdownOption
} from 'htx-ui-library';
import { buildSalutationOptions } from '../../../../services/form/salutation-options';
import { FormErrorMessagesService } from '../../../../services/form/form-error-messages.service';

@Component({
  selector: 'app-registration-step-1-user',
  imports: [
    ReactiveFormsModule,
    TranslocoDirective,
    RouterLink,
    AlertComponent,
    ButtonComponent,
    CheckboxFieldWithErrorComponent,
    FormSectionComponent,
    TextFieldWithErrorComponent,
    DropdownFieldWithErrorComponent
  ],
  templateUrl: './registration-step-1-user.component.html',
  styleUrl: './registration-step-1-user.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RegistrationStep1UserComponent {
  private translocoService = inject(TranslocoService);
  readonly errorMessagesService = inject(FormErrorMessagesService);

  readonly userForm = input.required<FormGroup>();
  readonly userFormFieldLabels = input.required<{ [key: string]: string }>();
  readonly autoFillRequested = output<void>();

  readonly salutationOptions = signal<DropdownOption[]>(buildSalutationOptions(this.translocoService));

  autoFill() {
    this.autoFillRequested.emit();
  }
}
